<div style="overflow: auto;" class="p-32 pt-24">
    <!--FILTERS-->
    <form [formGroup]="searchForm" fxLayout="row wrap">

        <span fxFlex="1 1 100%" class="mb-20"><strong>{{'ALERTS.FILTERS.SEARCH' | translate}}</strong></span>

        <!-- STATUS_DESCRIPTION DROPDOWN -->
        <mat-label fxFlex="100">{{'ALERTS.FIELDS.STATUS_DESCRIPTION' | translate}}
        </mat-label>
        <mat-form-field appearance="outline" floatLabel="always" class="mb-12" fxFlex="100%" color="accent">
            <mat-select formControlName="status">
                <ng-container *ngFor="let item of statusData">
                    <mat-option *ngIf="item.description != 'Closed'" [value]="item.id">
                        {{ "ALERTS.STATUS." + item.description | translate}}
                    </mat-option>
                </ng-container>
            </mat-select>
        </mat-form-field>

        <div fxLayout="column" fxFlex="100%" class="mb-8">
            <mat-label> {{ 'ALERTS.FIELDS.ALERTCODE' | translate }}</mat-label>
            <mat-form-field fxFlex="100%" appearance="outline">
                <input matInput formControlName="alertCode" type="number" autocomplete="off"
                    [maxlength]="textFiltersMaxLength">
            </mat-form-field>
        </div>

        <div fxLayout="column" fxFlex="100%" class="mb-8">
            <mat-label> {{ 'ALERTS.FIELDS.DESCRIPTION' | translate }}</mat-label>
            <mat-form-field fxFlex="100%" appearance="outline">
                <input matInput formControlName="description" autocomplete="off"
                    [maxlength]="textFiltersMaxLength">
            </mat-form-field>
        </div>
    </form>

    <!--TABLE-->
    <div fxLayout="row" fxLayoutAlign="flex-end center">
        <button fxFlex="0 1 auto" color="accent" mat-raised-button (click)="getPaged()"
            [disabled]="searchForm.invalid" class="mx-8">
            {{'COMMON_LIST.ACTIONS.APPLY' | translate}}
        </button>
        <button fxFlex="0 1 auto" color="primary" mat-raised-button (click)="clearFilters()" class="mx-8">
            {{'COMMON_LIST.ACTIONS.CLEAR' | translate}}
        </button>
    </div>

    <div style="overflow: auto;" class="associate-table">
        <div class="ticket-table-container" fxLayout="row">
            <mat-table class="ticket-table" #table [dataSource]="dataSource" matSort>
                <ng-container matColumnDef="ALERTCODE">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                        {{'ALERTS.FIELDS.ALERTCODE' | translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let item">
                        <p> {{item.alertCode }}</p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="ALERTENTITY">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                        {{'ALERTS.FIELDS.ALERTENTITY' | translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let item" [title]="item.entity">
                        <p> {{item.entity }}</p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="INTERNALID">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                        {{'ALERTS.FIELDS.INTERNALID' | translate}}
                    </mat-header-cell>
                    <mat-cell fxLayoutAlign="center center" *matCellDef="let item">
                        <p class="text-truncate">
                            {{item.internalId}}</p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="SOURCEID">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                        {{'ALERTS.FIELDS.SOURCEID' | translate}}
                    </mat-header-cell>
                    <mat-cell fxLayoutAlign="center center" *matCellDef="let item">
                        <p class="text-truncate">
                            {{item.sourceId}}</p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="DESCRIPTION">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                        {{'ALERTS.FIELDS.DESCRIPTION' | translate}}
                    </mat-header-cell>
                    <mat-cell fxLayoutAlign="center center" *matCellDef="let item">
                        <p class="text-truncate">
                            {{item.description}}</p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Source.Description">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                        {{'ALERTS.FIELDS.SOURCE_DESCRIPTION' | translate}}
                    </mat-header-cell>
                    <mat-cell fxLayoutAlign="center center" *matCellDef="let item">
                        <p class="text-truncate">
                            {{item.sourceDescription}}</p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="CREATEDDATE">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                        {{'ALERTS.FIELDS.CREATEDDATE' | translate}}
                    </mat-header-cell>
                    <mat-cell fxLayoutAlign="center center" *matCellDef="let item">
                        <p class="text-truncate">
                            {{item.createdDate | date:'yyyy-MM-dd'}}</p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Criticality.Description">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                        {{'ALERTS.FIELDS.CRITICALITY_DESCRIPTION' | translate}}
                    </mat-header-cell>
                    <mat-cell fxLayoutAlign="center center" *matCellDef="let item">
                        <p class="text-truncate">
                            {{item.criticalityDescription}}</p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="DUEDATE">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                        {{'ALERTS.FIELDS.DUEDATE' | translate}}
                    </mat-header-cell>
                    <mat-cell fxLayoutAlign="center center" *matCellDef="let item">
                        <p class="text-truncate">
                            {{item.dueDate | date:'yyyy-MM-dd'}}</p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Status.Description">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                        {{'ALERTS.FIELDS.STATUS_DESCRIPTION' | translate}}
                    </mat-header-cell>
                    <mat-cell fxLayoutAlign="center center" *matCellDef="let item">
                        <p class="text-truncate">
                            {{item.statusDescription}}</p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="MODIFIEDDATE">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                        {{'ALERTS.FIELDS.MODIFIEDDATE' | translate}}
                    </mat-header-cell>
                    <mat-cell fxLayoutAlign="center center" *matCellDef="let item">
                        <p class="text-truncate">
                            {{item.modifiedDate | date:'yyyy-MM-dd'}}</p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Resolution.Description">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="cell150-w">
                        {{'ALERTS.FIELDS.RESOLUTION_DESCRIPTION' | translate}}
                    </mat-header-cell>
                    <mat-cell fxLayoutAlign="center center" *matCellDef="let item" class="cell200-w">
                        <p class="text-truncate" [title]='item.resolutionDescription && ("ALERTS.MASSIVE_ACTIONS." + item.resolutionDescription) | translate'>
                            {{item.resolutionDescription && ("ALERTS.MASSIVE_ACTIONS." + item.resolutionDescription) | translate}}</p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="ACTIONS" stickyEnd>
                    <mat-header-cell *matHeaderCellDef class="cell200-w"></mat-header-cell>
                    <mat-cell *matCellDef="let item" fxLayout="row"  class="cell200-w" class="px-16"
                        fxLayoutAlign="center center" style="border-left: 1px solid rgba(128, 128, 128, 0.26);">
                        <button mat-icon-button class="m-4" color="primary" (click)="selectAlert(item.alertId)"
                        matTooltip="{{'COMMON_LIST.SELECT' | translate}}" matTooltipPosition="above">
                            <mat-icon>task_alt</mat-icon>
                        </button>
                        <button mat-icon-button color="primary" class="m-4" (click)="viewAlertDetail(item.alertId)"
                        matTooltip="{{'ALERTS.COMPLETE_ALERT.DETAIL' | translate}}" matTooltipPosition="above">
                            <mat-icon>arrow_forward</mat-icon>
                        </button>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns;"></mat-header-row>

                <mat-row *matRowDef="let item; columns: displayedColumns;" class="ticket" [ngClass]="{'selected-alert': item.alertId == idSelected}"
                    [class.user-pointer]="false" matRipple>
                </mat-row>

            </mat-table>

            <!-- GRID LOADER -->
            <div *ngIf="loadingDataSource"
                style="max-height: 30px; position: absolute; left: 50%; top: 50%; transform: translate(-50%,-50%);">
                <mat-progress-spinner [diameter]="40" color="primary" mode="indeterminate">
                </mat-progress-spinner>
            </div>
            <!-- / GRID LOADER -->
        </div>
    </div>

    <!--/TABLE-->

    <div class="associate-cards">
        <ng-container *ngFor="let alert of dataSource.data">
            <mat-card class="my-8">
                <div fxFlex="85" fxLayout="row wrap" fxLayoutAlign="flex-start center">
                    <div fxFlex="100" class="p-8">
                        <div fxFlex="70">{{'ALERTS.FIELDS.ALERTCODE' | translate}}: </div>
                        <div fxFlex="30"><b>{{alert.alertCode}}</b></div>
                    </div>
                    
                    <div fxFlex="100" class="p-8">
                        <div fxFlex="50">{{'ALERTS.FIELDS.ALERTENTITY' | translate}}: </div>
                        <div fxFlex="50"><b>{{alert.entity}}</b></div>
                    </div>

                    <div fxFlex="100" class="p-8">
                        <div fxFlex="50">{{'ALERTS.FIELDS.DESCRIPTION' | translate}}: </div>
                        <div fxFlex="50"><b>{{alert.description}}</b></div>
                    </div>

                    
                </div>
                <div fxFlex="25" fxLayout="row wrap">
                    <div fxFlex="100" class="p-8">
                        <button mat-icon-button class="m-4" color="primary" (click)="selectAlert(alert.alertId)"
                            matTooltip="{{'COMMON_LIST.SELECT' | translate}}" matTooltipPosition="above">
                            <mat-icon>task_alt</mat-icon>
                        </button>
                        <button mat-icon-button class="m-4" (click)="viewAlertDetail(alert.alertId)"
                            matTooltip="{{'ALERTS.COMPLETE_ALERT.DETAIL' | translate}}" matTooltipPosition="above"><!---->
                            <mat-icon>arrow_forward</mat-icon>
                        </button>
                    </div>
                </div>
            </mat-card>
        </ng-container>
    </div>
</div>
